<script setup lang="ts">
import { useTabsStore } from '@/stores/useTabsStore';
import { helpcenterTabs } from '@/constants/tabs';

const tabsStore = useTabsStore();
</script>

<template>
  <v-window
    v-model="tabsStore.tabs.helpcenter"
    :class="$style.helpcenterSideBarVWindow"
    data-testid="helpcenterSideBarVWindow"
    :touch="false"
  >
    <v-window-item
      v-for="(tabValue, tabKey, tabIndex) in helpcenterTabs"
      :key="tabIndex"
      :value="tabKey"
    >
      <slot :tab-value="tabValue" :tab-key="tabKey" :tab-index="tabIndex">
      </slot>
    </v-window-item>
  </v-window>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarVWindow {
}
</style>
